// extracted by mini-css-extract-plugin
module.exports = {"ArticleMeta":"ArticleMeta_ArticleMeta__1VG6h","separator":"ArticleMeta_separator__11OxY","readingTime":"ArticleMeta_readingTime__1u9-Y","tags":"ArticleMeta_tags__1IJ9w"};